import React, {useMemo} from "react";
import {InputAdornment} from "@mui/material";
import DocumentAttachButton from "../../components/files/DocumentAttachButton";

const useDocumentAttachAdornment = ({
  documentUploadEnabled,
  handleAttach,
  isReadOnly,
  isCurrentRequest,
  isStopping,
  pendingConfirmation,
  pendingAttachments,
  maxAttachments,
}) =>
  useMemo(() => {
    if (!documentUploadEnabled || isReadOnly) {
      return undefined;
    }
    return {
      startAdornment: (
        <InputAdornment position="start">
          <DocumentAttachButton
            onAttach={handleAttach}
            disabled={isCurrentRequest || isStopping || !!pendingConfirmation}
            maxReached={pendingAttachments.length >= maxAttachments}
            maxAttachments={maxAttachments}
          />
        </InputAdornment>
      ),
    };
  }, [
    documentUploadEnabled,
    handleAttach,
    isReadOnly,
    isCurrentRequest,
    isStopping,
    pendingConfirmation,
    pendingAttachments,
    maxAttachments,
  ]);

export default useDocumentAttachAdornment;
